import { Component, OnInit, Input } from '@angular/core';
import { WizardStep } from 'src/app/wizard/wizard.component';
import { BillingOrdenControlWizardService } from 'src/app/services/billing/billing-orden-control-wizard.service';

@Component({
  selector: 'app-billing-orden-control-scann',
  templateUrl: './billing-orden-control-scann.component.html',
  styleUrls: ['./billing-orden-control-scann.component.css']
})
export class BillingOrdenControlScannComponent  implements OnInit, WizardStep {

  @Input() medicalorderId?: number;
  isInit: boolean;
  loadingInit: boolean;
  loading: boolean;

  get completed(): boolean { return true; }

  save() { }

  activate() { }

  get valid(): boolean {
    return this.completed;
  }


  async ngOnInit() {
    this.isInit = true;
  }

}
